const Error=()=>{
    return (
        <div className={'flex items-center justify-center h-screen w-screen  bg-black text-white'}
        >
           <h1 className={'text-6xl'}>Error page </h1>
        </div>
    )
}
export default Error